module.exports = __webpack_public_path__ + "assets/img/图片2.3ce5495c.png";